export default "__VITE_ASSET__C0S_pSjp__"